module.exports = __webpack_public_path__ + "img/instagram-logo.caed25cb.png";